import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "../App.css";
import { AnimatePresence } from "framer-motion";
import Footer from "../Components/Footer";
import { UserProvider } from "../context/userContext";

// Безопасное получение Telegram WebApp
const getTelegramWebApp = () => {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    return window.Telegram.WebApp;
  }
  return null;
};

const Home = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [hasVisitedBeforee, setHasVisitedBeforee] = useState(false);
  const [hider, setHider] = useState(false);

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => e.preventDefault());
    document.addEventListener("keydown", (e) => {
      if (
        (e.ctrlKey && ["u", "s"].includes(e.key)) ||
        (e.ctrlKey && e.shiftKey && e.key === "i")
      ) {
        e.preventDefault();
      }
    });

    return () => {
      document.removeEventListener("contextmenu", () => {});
      document.removeEventListener("keydown", () => {});
    };
  }, []);

  useEffect(() => {
    const tele = getTelegramWebApp();
    
    document.body.style.backgroundColor = "#180749";
    
    // Проверяем, что мы внутри Telegram
    if (tele) {
      tele.setBackgroundColor("#180749");
      tele.setHeaderColor("#180749");
      tele.ready();
      tele.expand();
      
      if (tele.HapticFeedback) {
        tele.HapticFeedback.impactOccurred("medium");
      }
    }
    
    setTimeout(() => setLoading(false), 2000);

    // Вибрация работает и в браузере (если поддерживается)
    if (navigator.vibrate) navigator.vibrate(100);
  }, []);

  useEffect(() => {
    const visited = localStorage.getItem("hasVisitedBeforee");
    if (visited) {
      setHasVisitedBeforee(true);
    } else {
      setHider(true);
      localStorage.setItem("hasVisitedBeforee", "true");
    }
    setTimeout(() => setHider(false), 1000);
  }, []);

  useEffect(() => {
    const isDashboardRoute =
      location.pathname.startsWith("/dashboardAdx") ||
      location.pathname.startsWith("/dashboard");

    if (isDashboardRoute) {
      document.getElementById("footermain")?.style?.setProperty("display", "none");
      return;
    }
  }, [location.pathname]);

  return (
    <div className="relative w-full min-h-screen pt-20">
      {/* Основной контент с прокруткой */}
      <div className="h-[calc(100vh-67px)] overflow-y-auto scroll-smooth">
        <div className="w-full max-w-[720px] mx-auto pt-6 px-4 pb-6">
          <UserProvider>
            <AnimatePresence mode="wait">
              <React.Fragment key={location.pathname}>
                <Outlet />
              </React.Fragment>
            </AnimatePresence>
          </UserProvider>
        </div>
      </div>

      {/* Футер фиксированный */}
      <div
        id="footermain"
        className={`${
          loading || hider ? "hidden" : "block"
        } z-30 fixed bottom-0 left-0 right-0 bg-white pt-3 pb-6`}
      >
        <div className="w-full max-w-[720px] mx-auto px-4">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Home;